const numberAlignRight = () => ({
  style: {
    textAlign: 'right',
  },
})

const textAlignCenter = () => ({
  style: {
    textAlign: 'center',
  },
})

export default [
  {
    Header: 'Tipo',
    id: 'type',
    accessor: 'type',
    width: 100,
  },
  {
    Header: 'Data movimentação',
    id: 'createdAt',
    accessor: 'createdAt',
    width: 140,
  },
  {
    Header: 'Usuário',
    id: 'user',
    accessor: 'user',
    width: 250,
  },
  {
    Header: 'Quantidade',
    id: 'appliedQuantity',
    accessor: 'appliedQuantity',
    width: 80,
    getProps: numberAlignRight,
  },
  {
    Header: 'Saldo final',
    id: 'balance',
    accessor: 'balance',
    width: 80,
    getProps: numberAlignRight,
  },
  {
    Header: 'Código do pedido',
    id: 'orderCode',
    accessor: 'orderCode',
    width: 160,
    getProps: textAlignCenter,
  },
  {
    Header: 'Nota',
    id: 'invoice',
    accessor: 'invoice',
    width: 290,
    getProps: textAlignCenter,
    sortMethod: (a: any, b: any) => {
      const valueA = a.props.children
      const valueB = b.props.children

      if (valueA < valueB) {
        return -1
      }
      if (valueA > valueB) {
        return 1
      }

      return 0
    },
  },
  {
    Header: 'Recebimento',
    id: 'receivement',
    accessor: 'receivement',
    width: 90,
    getProps: textAlignCenter,
    sortMethod: (a: any, b: any) => {
      const valueA = a.props.children
      const valueB = b.props.children

      if (valueA < valueB) {
        return -1
      }
      if (valueA > valueB) {
        return 1
      }

      return 0
    },
  },
  {
    Header: '',
    id: 'dumb',
    accessor: 'dumb',
    width: 1,
  },
]
